import { render } from "./Footer.vue?vue&type=template&id=6fd56d7a&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=6fd56d7a&scoped=true&lang=css"

import exportComponent from "/Users/timothyjoseph/Projects/simplest-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fd56d7a"]])

export default __exports__